import { convertToVariantCategories } from "./convertToVariantCategories";

import type { ticketState } from "../../../../modules/ticket";
import type { GoodsVenueSelector } from "components/event/goods/GoodsVenueSelector";
import type { ComponentProps, MouseEventHandler } from "react";

type Input = {
  eventId: string;
  classGoodsList: ticketState["eventGoods"];
  repGoods: ticketState["eventGoodsMap"][number];
  selectablePlaces: ComponentProps<typeof GoodsVenueSelector>["venues"];
  isAdmin: boolean;
  watchlistItemIds: Set<string>;
  handleClickWatch: (goodsId: string) => MouseEventHandler<HTMLButtonElement>;
};

export const useEventGoodsItemInfo = (input: Input) => {
  const { classGoodsList } = input;

  const variantCategories = convertToVariantCategories({
    variantList: classGoodsList,
  });

  return {
    variantCategories,
  };
};
